import React from "react";
import { X } from "lucide-react";
import { ReadableCard } from "../Sticker";
import LinkifiedText from "../LinkifiedText";

export default function PriorityBroadcastCard({ broadcast, onDismiss }) {
  if (!broadcast) return null;

  const contextLine = [broadcast.event_name, broadcast.host_label?.trim()].filter(Boolean).join(" · ");

  function handleDismiss() {
    onDismiss(broadcast.id);
  }

  return (
    <section
      className="max-w-page mx-auto px-4 mt-3"
      data-testid="feed-priority-broadcast"
      aria-label="Host shout-out"
    >
      <ReadableCard
        className="relative p-0 overflow-hidden bg-plum/5 cursor-pointer"
        onClick={handleDismiss}
      >
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleDismiss();
          }}
          className="absolute top-2 right-2 z-10 shrink-0 rounded-md2 p-1.5 min-w-[32px] min-h-[32px] flex items-center justify-center text-ink/45 hover:text-ink/70 hover:bg-white/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2"
          aria-label="Dismiss shout-out"
          data-testid="feed-priority-broadcast-dismiss"
        >
          <X className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden />
        </button>
        <div className="p-4 pr-11 min-w-0">
          <p className="font-ui text-[14px] font-medium text-ink/80 min-w-0 break-words [overflow-wrap:anywhere] whitespace-pre-line">
            <LinkifiedText>{broadcast.message}</LinkifiedText>
          </p>
          <p className="font-ui text-[12px] font-medium text-ink/55 mt-1">
            {broadcast.created_at
              ? new Date(broadcast.created_at).toLocaleString("en-GB", {
                  day: "numeric",
                  month: "short",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : ""}
          </p>
          {contextLine && (
            <p className="font-ui text-[12px] font-medium text-ink/55 mt-1 min-w-0 break-words [overflow-wrap:anywhere]">
              {contextLine}
            </p>
          )}
        </div>
      </ReadableCard>
    </section>
  );
}
